var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
const x400StateKeys = [
    'analogInput1',
    'analogInput2',
    'analogInput3',
    'analogInput4',
    'analogInput5',
    'analogInput6',
    'analogInput7',
    'analogInput8',
    'digitalInput1',
    'digitalInput2',
    'digitalInput3',
    'digitalInput4',
    'digitalInput5',
    'digitalInput6',
    'digitalInput7',
    'digitalInput8',
    'digitalInput9',
    'digitalInput10',
    'digitalInput11',
    'digitalInput12',
    'digitalInput13',
    'digitalInput14',
    'digitalInput15',
    'digitalInput16',
    'digitalIO1',
    'digitalIO2',
    'lat',
    'long',
    'minRecRefresh',
    'register1',
    'relay1',
    'relay2',
    'relay3',
    'relay4',
    'relay5',
    'relay6',
    'relay7',
    'relay8',
    'relay9',
    'relay10',
    'relay11',
    'relay12',
    'relay13',
    'relay14',
    'relay15',
    'relay16',
    'serialNumber',
    'timezoneOffset',
    'utcTime',
    'vin',
];
function isControlByWebContactClosureConfig(config) {
    return 'type' in config && 'index' in config;
}
export class ControlByWebX400 {
    constructor(http, state, log) {
        this.http = http;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.authToken = 'YWRtaW46d2VicmVsYXk=';
        this.channels = [];
        this.initialStates = {};
        this.timeouts = new Timeouts();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.contactClosure = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                if (key in this.state.contactClosures.values) {
                    return this.state.contactClosures.values[key];
                }
                else if (key in this.initialStates) {
                    return this.initialStates[key];
                }
                else {
                    this.log.error(`no value for key = ${key}`);
                    return false;
                }
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const resp = yield this.httpGetJson('/state.json', `?${key}=${value ? '1' : '0'}`, tags);
                const state = (_a = this.parseStateResponse(resp)) !== null && _a !== void 0 ? _a : {};
                return key in state
                    ? state[key] === '1'
                    : this.state.contactClosures.values[key];
            }),
            getKey: (config) => {
                if (!isControlByWebContactClosureConfig(config)) {
                    throw new Error(`invalid contact closure config: ${JSON.stringify(config)}`);
                }
                return `${config.type}${config.index}`;
            },
            validate: (config) => __awaiter(this, void 0, void 0, function* () {
                if (!isControlByWebContactClosureConfig(config)) {
                    this.log.error(`invalid contact closure config: ${JSON.stringify(config)}`);
                    return { type: 'missing', index: 'missing' };
                }
                if (config.type !== 'relay' && config.type !== 'digitalIo') {
                    return { type: 'incompatible', index: 'incompatible' };
                }
                for (const chan of this.channels) {
                    if (chan.type === config.type && chan.index == config.index) {
                        return { type: 'ok', index: 'ok' };
                    }
                }
                return { type: 'missing', index: 'missing' };
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _b;
                this.channels.length = 0;
                const resp = yield this.httpGetJson(`/state.json`, undefined, tags);
                const state = (_b = this.parseStateResponse(resp)) !== null && _b !== void 0 ? _b : {};
                this.forEachStateEntry(state, (type, index, value) => {
                    const filters = {};
                    if (type === 'relay' || type === 'digitalIo')
                        filters.contactClosures = true;
                    this.channels.push({ filters, index, type });
                });
                return { channels: this.channels };
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    var _c;
                    const resp = yield this.httpGetJson('/state.json', undefined, ['poll']);
                    const state = (_c = this.parseStateResponse(resp)) !== null && _c !== void 0 ? _c : {};
                    this.forEachStateEntry(state, (type, index, value) => {
                        const key = `${type}${index}`;
                        if (key in this.state.contactClosures.values) {
                            this.state.contactClosures.update(key, value === '1');
                        }
                    });
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.destroyAll();
            this.initialStates = {};
            const resp = yield this.httpGetJson(`/state.json`, undefined, ['configure']);
            const state = (_a = this.parseStateResponse(resp)) !== null && _a !== void 0 ? _a : {};
            this.forEachStateEntry(state, (type, index, value) => {
                const key = `${type}${index}`;
                this.initialStates[key] = value === '1';
            });
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.destroyAll();
        });
    }
    onInitialize(credentials) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const username = (_a = credentials.username) !== null && _a !== void 0 ? _a : 'admin';
            const password = (_b = credentials.password) !== null && _b !== void 0 ? _b : 'webrelay';
            this.authToken = btoa(username + password);
            try {
                const resp = yield this.httpGetJson(`/state.json`, undefined, ['initialize']);
                const state = (_c = this.parseStateResponse(resp)) !== null && _c !== void 0 ? _c : {};
                if (state.serialNumber) {
                    return 'connected';
                }
                else {
                    return 'verifyFailed';
                }
            }
            catch (error) {
                return 'connectFailed';
            }
            return 'connectFailed';
        });
    }
    // other class methods
    forEachStateEntry(state, fn) {
        var _a;
        for (const [key, value] of Object.entries(state)) {
            if (value === undefined)
                continue;
            const match = /^([a-zA-Z]+)(\d+)$/.exec(key);
            if (!match)
                continue;
            let type = ((_a = match[1]) !== null && _a !== void 0 ? _a : '').toLowerCase();
            let index = parseInt(match[2], 10);
            if (type === 'relay') {
                fn(type, index, value);
            }
            else if (type === 'digitalio') {
                fn('digitalIo', index, value);
            }
        }
    }
    httpGetJson(path, vars, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = (yield this.http.requestJson('get', `${path}${vars ? vars : ''}`, Object.assign({ headers: { Authorization: `Basic ${this.authToken}` } }, (tags ? { tags } : undefined))));
            return resp;
        });
    }
    parseStateResponse(data) {
        if (typeof data === 'object' && data !== null) {
            const x400State = {};
            for (const key of x400StateKeys) {
                const value = data[key];
                if (value !== undefined) {
                    if (typeof value === 'string') {
                        x400State[key] = value;
                    }
                    else {
                        this.log.error(`non-string value in state response`);
                    }
                }
            }
            return x400State;
        }
        else {
            this.log.debug(`jsj: not an object`);
        }
        return undefined;
    }
}
// static properties
ControlByWebX400.driverType = 'httpDriver';
ControlByWebX400.key = '-MsBSyMo4saney4Slkcb';
ControlByWebX400.httpRequestOptions = {
    prettyCommands: false,
    scheme: 'http',
};
